import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconAdultsOnly = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconAdultsOnly",
  viewBox: "0 0 20 20",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M10 1.7A8.3 8.3 0 0 0 1.7 10a8.3 8.3 0 0 0 8.3 8.3 8.3 8.3 0 0 0 8.3-8.3A8.3 8.3 0 0 0 10 1.7m-.1 5.5h.1-.05c.48 0 .96.1 1.25.4.3.2.5.6.5 1 0 .3-.1.5-.3.8a2 2 0 0 1-.7.6l.9.7c.2.3.3.5.3.8q0 .75-.6 1.2c-.4.2-.8.4-1.4.4-.7 0-1.2-.2-1.5-.4-.4-.3-.5-.7-.5-1.1s0-.7.2-1L9 10l-.7-.6-.2-.8c0-.4.2-.8.5-1 .39-.3.78-.4 1.35-.4zm-4.6.1h1V13H5.1V8.6l-.4.4-.6.5-.6-.7zM10 8c-.3 0-.4 0-.5.2-.2 0-.2.2-.2.4l.1.4.6.4.5-.4.1-.4-.1-.4A1 1 0 0 0 10 8m4 .2h.9v1.6h1.5v.8h-1.5v1.5H14v-1.5l.1-.1h-1.5v-.8H14zm-4.2 2.3c-.6.3-.8.6-.8 1h-.1c0 .2.1.4.3.5l.6.2c.3 0 .6 0 .7-.2.2-.1.2-.3.2-.5s0-.3-.2-.5c-.1-.2-.4-.3-.7-.5"
  })
}));
IconAdultsOnly.displayName = 'IconAdultsOnly';